module.exports = __webpack_public_path__ + "img/a-topazio.09b0482d.webp";